// Copyright (c) Ping. All rights reserved.

import { ActivityPanel } from '@features/activity';

/**
 * Standalone `/activity` route host — renders the shared `<ActivityPanel>`
 * (no close button; the route is its own destination). The chat-header bell
 * renders the same panel as an in-panel TabView scene with a close button —
 * see `ChatRouteHost`.
 */
export function ActivityRouteHost(): JSX.Element {
  return <ActivityPanel />;
}
